import { useEffect, useState } from 'react';
import getFileURL from '../actions/getFileURL';

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    filePath: string;
    alt: string;
}

const AvatarImage: React.FC<AvatarImageProps> = ({
    filePath,
    alt,
    ...rest
}) => {
    const [src, setSrc] = useState<string | null>(null);

    useEffect(() => {
        let isMounted = true;
        getFileURL(filePath).then((url) => {
            if (isMounted) setSrc(url);
        });
        return () => {
            isMounted = false;
        };
    }, [filePath]);

    if (!src) return null;

    return <img src={src} alt={alt} {...rest} />;
};

export default AvatarImage;
